export default {
  benefits: {
    earn_points: 'Câștigă puncte la fiecare comandă',
    get_deals: 'Primește reduceri exclusive',
    redeem_points: 'Schimbă punctele pentru mâncare gratuită',
  },
};
